function Banner() { 
    return(
        <>
            <section className="banner-section">
                <div className="container">
                    <div className="banner-content">
                        <div className="banner-content_text">
                            <h2>Save <strong>Huge</strong> with out Cheap rental..</h2>
                            <p>Discover a wide range of vehicles from trusted local suppliers.<span>24/7</span> support</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
 }


 export default Banner;